import { activityFeedQueryOptions, nearbyFeedQueryOptions } from '@/api/queries/activity';
import { useInfiniteQuery } from '@tanstack/react-query';

export { FEED_QUERY_KEYS } from '@/api/queries/activity';

export function useActivityFeed() {
  return useInfiniteQuery(activityFeedQueryOptions());
}

export function useNearbyFeed(latitude: number | null, longitude: number | null) {
  return useInfiniteQuery({
    ...nearbyFeedQueryOptions(latitude ?? 0, longitude ?? 0),
    enabled: latitude !== null && longitude !== null,
  });
}
